import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../../layouts/DefaultLayout'
import ResetPasswordForm, {
  ResetPasswordFormProps,
} from '../../../components/forms/PasswordForm/ResetPasswordForm'
import * as SC from '../styled'

export type ResetPasswordTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  resetPasswordForm: ResetPasswordFormProps
}

const ResetPasswordTemplate: FC<ResetPasswordTemplateProps> = (props) => {
  const { layout, resetPasswordForm } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <ResetPasswordForm {...resetPasswordForm} />
      </SC.Content>
    </DefaultLayout>
  )
}

export default ResetPasswordTemplate
